import { Capacitor } from '@capacitor/core';

/**
 * Détecte si l'app tourne sur une plateforme native (Capacitor)
 */
export const isNativePlatform = (): boolean => {
  return Capacitor.isNativePlatform();
};

/**
 * Retourne la plateforme actuelle
 */
export const getPlatform = (): 'ios' | 'android' | 'web' => {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios' || platform === 'android') {
    return platform;
  }
  return 'web';
};
